const style = {
  aria: {
    label: 'more',
    controls: 'long-button',
    id: 'long-menu',
  },
} as const;

export default style;
